// pages/PersonalData/components/DataCard/DataCard.tsx
import React from 'react';
import './DataCard.scss';

export interface DataCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  selected: boolean;
  onClick: () => void;
  className?: string;
}

const DataCard: React.FC<DataCardProps> = ({
                                             icon,
                                             title,
                                             description,
                                             selected,
                                             onClick,
                                             className = ''
                                           }) => {
  return (
    <div
      className={`
                data-card 
                ${selected ? 'data-card--selected' : ''} 
                ${className}
            `}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
    >
      <div className="data-card__icon">
        {icon}
      </div>
      <div className="data-card__content">
        <h3 className="data-card__title">{title}</h3>
        <p className="data-card__description">{description}</p>
      </div>
      <div className="data-card__check">
        {selected && <span className="data-card__check-icon">✓</span>}
      </div>
    </div>
  );
};

export default DataCard;